import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";

import { TagsRoutes } from "./Constants/routes";

const Tags = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {TagsRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/tag" />
      </Switch>
    </>
  );
};

export default Tags;
